export default __webpack_public_path__ + "static/media/1924.50e39817.png";